import React, {useState} from 'react'
import { headerStyles } from '../../styles/header';
import DrawerComponent from "../common/drawer";
import {useTheme, useMediaQuery, Typography, Box, Modal, IconButton, AppBar, Toolbar,} from "@mui/material";
// import {NavLink} from "react-router-dom";
import AuthModal from '../authentication/authModal';
import { HashLink as NavLink} from 'react-router-hash-link';
import {Link} from "react-router-dom"
import { useSelector } from "react-redux";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  outline:'none',
  borderRadius:2,
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 5,
  pb:8
};

const Header = () => {
  const [active, setActive] = useState(0)
  const { arborist, isLoggedIn } = useSelector(({arboristLogin})=>arboristLogin)
  console.log("arborist", arborist)
    const classes = headerStyles()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

  return (
    <section id="home">
       <AppBar position="fixed" className={classes.headerView} elevation={0}>
        <Toolbar className={classes.toolbar}>     
            <div className ={classes.logo}>                        
                <NavLink smooth to ='/#home'><img src = "assets/images/logo.png" className={classes.logoView} /></NavLink>             
            </div>   
            {isMobile ? (
            <DrawerComponent />
            ) : (<>
              <ul className={classes.navlist}>
             <li className={classes.listItem}>
                <NavLink smooth to='/#home'  
                  onClick={()=>setActive(1)} 
                  style={{color: active === 1 ? "rgb(115 74 153)":"#222222"}} 
                  className={classes.navlink}>
                  Home
                </NavLink>                
                </li>
                <li className={classes.listItem}>
                <NavLink smooth to='/#arboristWork' 
                  onClick={()=>setActive(2)} 
                  style={{color: active === 2 ? "rgb(115 74 153)":"#222222"}} 
                  className={classes.navlink}>
                  What We do
                </NavLink>                
                </li>
                <li className={classes.listItem}>
                <NavLink smooth to='/#leader' 
                  onClick={()=>setActive(3)} 
                  style={{color: active === 3 ? "rgb(115 74 153)":"#222222"}} 
                  className={classes.navlink}>
                  Our Leader
                </NavLink>
                </li>                
                <li className={classes.listItem}>
                <NavLink smooth to='/#services' 
                  onClick={()=>setActive(4)} 
                  style={{color: active === 4 ? "rgb(115 74 153)":"#222222"}} 
                  className={classes.navlink}>
                  Services      
                  </NavLink>
                  </li>
                  <li className={classes.listItem}>
                <NavLink smooth to='/#visit' 
                  onClick={()=>setActive(5)} 
                  style={{color: active === 5 ? "rgb(115 74 153)":"#222222"}} 
                  className={classes.navlink}>
                  Schedule a visit
                </NavLink>                
                </li>
                  <li className={classes.listItem}>
                    <NavLink smooth to='/#contact'  
                      onClick={()=>setActive(6)} 
                      style={{color: active === 6 ? "rgb(115 74 153)":"#222222"}} 
                      className={classes.navlink}>
                       Contact Us      
                    </NavLink> 
                  </li>
                  <li className={classes.listItem} onClick={handleOpen} style={{cursor:"pointer", color:"#222222"}}>
                    Login
                    {/* <NavLink to={auth ? "/dashboard" : "/login"}>Admin Login</NavLink> */}
                  </li>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <AuthModal handleClose={handleClose} />
                    </Box>
                  </Modal>
                </ul>
              </>)}
        </Toolbar>            
      </AppBar>
    </section>              
           
  )
}

export default Header
